import { isError } from 'lodash';
import * as Yup from 'yup';

import { ASSET_MODAL_PARAMS_TO_OMIT } from '~/constants/assetModalParams';
import { containsRestrictedPathChars } from '~/utils/FileUtils';
import { getCurrentQuery } from '~/utils/Url';

const ASSET_TITLE_MAX_LENGTH = 255;

export const AssetTitleValidationSchema = Yup.object().shape({
  title: Yup.string()
    .max(ASSET_TITLE_MAX_LENGTH, `Cannot be longer than ${ASSET_TITLE_MAX_LENGTH} characters`)
    .required('Title is required')
    .test(
      'restricted-char-validation',
      'Characters : and | cannot be used',
      (val) => !containsRestrictedPathChars(val || ''),
    )
    .matches(/^[^\n]*$/, 'No line breaks allowed'),
});

export const validateAssetTitle = (value: string): string | undefined => {
  try {
    AssetTitleValidationSchema.validateSync({ title: value });
  } catch (error) {
    return isError(error) ? error.message : 'Invalid title';
  }
};

export const assetModalParamsToOmit = ASSET_MODAL_PARAMS_TO_OMIT;

export const getQueryWithNullAssetModalParams = () => {
  const query = getCurrentQuery();
  assetModalParamsToOmit.forEach((param) => {
    query[param] = null;
  });
  return query;
};
